interface LabelValueProps {
  label: string;
  value: string;
  className?: string;
}

const LabelValue = ({ label, value, className = "" }: LabelValueProps) => (
  <div className="flex flex-col gap-1">
    <span className="text-xs font-normal text-primaryGray-4">{label}</span>
    <span className={`text-sm font-semibold text-primaryGray-1 ${className}`}>
      {value}
    </span>
  </div>
);

export default LabelValue;
